import { useMutation, useQueryClient } from 'react-query';
import { toastr } from 'react-redux-toastr';
import RentForecastService from '../../services/rentForecastService';
import useIntl from '../../hooks/useIntl';
import messages from './messages';

const useRentForecastUpdateMutation = (
  organizationId,
  propertyId,
  rentForecastId,
) => {
  const intl = useIntl();
  const queryClient = useQueryClient();

  return useMutation(
    async (values) => {
      const payload = JSON.stringify(
        Object.keys(values).reduce((acc, key) => {
          acc[key] = values[key];
          return acc;
        }, {}),
      );

      return new RentForecastService().updateRentForecast(
        organizationId,
        propertyId,
        rentForecastId,
        payload,
      );
    },
    {
      onSuccess: (data) => {
        toastr.success(
          intl.formatMessage(messages.success),
          intl.formatMessage(messages.updatedForecast),
        );

        const queryKey = ['useRentForecastQuery', organizationId, propertyId];

        queryClient.setQueryData(queryKey, (oldData) => {
          if (!oldData) return oldData;

          return {
            ...oldData,
            rentForecasts: oldData?.rentForecasts?.map((item) => {
              const updatedItem = data.find((d) => d?.id === item?.id);
              return updatedItem ? updatedItem : item;
            }),
          };
        });
        queryClient.invalidateQueries(queryKey);
      },
      onError: (error) => {
        toastr.error('Error', error.toString(), {
          timeOut: 0,
          showCloseButton: true,
        });
      },
    },
  );
};

export default useRentForecastUpdateMutation;
